<template>
    <div class="certificate-example">
      <div class="example-img">
        <img :src="imageSrc" :alt="imageAlt" />
      </div>
      <div class="example-text">
        <h2 v-if="!customDescription">{{ title }}</h2>
        <p v-html="description"></p>
        <a :href="downloadLink" target="_blank">
          <button class="see-example" v-if="customLabel">
            {{ customLabel }}
          </button>
          <button class="see-example" v-else>
            Guarda esempio
          </button>
        </a>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'CertificateExample',
    props: {
      type: {
        type: String,
        required: true,
      },
      vehicle_type: {
        type: String,
        required: true,
      },
      customImageUrl: {
        type: String,
        default: ''
      },
      customImageName: {
        type: String,
        default: ''
      },
      customDescription: {
        type: String,
        default: ''
      },
      customLink: {
        type: String,
        default: ''
      },
      customLabel: {
        type: String,
        default: ''
      },
    },
    computed: {
      imageSrc() {
        if (this.customImageUrl && this.customImageUrl.trim() !== '') {
          return this.customImageUrl;
        }
        return {
          nominale: '../../../images/project-img/PlaceH_nominale.png',
          sponsor: '../../../images/project-img/PlaceH_nominale.png',
          'live-market': '../../../images/project-img/PlaceH_livemarket.png',
          storica: '../../../images/project-img/PlaceH_Storica.png',
          'ruote-classiche': '../../../images/project-img/PlaceH_Classiche.png',
        }[this.type];
      },
      title() {
        return {
          nominale: 'Quotazione Nominale',
          sponsor: 'Quotazione Nominale',
          'live-market': 'Report Live Market',
          storica: 'Quotazione Storica',
          'ruote-classiche': 'Quotazione Ruote Classiche',
        }[this.type];
      },
      imageAlt() {
        return {
          nominale: 'Esempio Certificato Quotazione Nominale Quattroruote',
          sponsor: 'Esempio Certificato Quotazione Sponsorizzata Quattroruote',
          'live-market': 'Esempio Certificato Quotazione Live Market Quattroruote',
          storica: 'Esempio Certificato Quotazione Storica Quattroruote',
          'ruote-classiche': 'Esempio Certificato Quotazione Ruote Classiche Quattroruote',
        }[this.type];
      },
      downloadLink() {
        if (this.customLink && this.customLink.trim() !== '') {
          return this.customLink;
        }
        const baseLink = 'api/download-example-quotation';
        const queryParams = `vehicle_type=${encodeURIComponent(this.vehicle_type)}`;
        const links = {
          nominale: `${baseLink}?quotation_type=nominale&${queryParams}`,
          sponsor: `${baseLink}?quotation_type=nominale&${queryParams}`,
          'live-market': `${baseLink}?quotation_type=live-market&${queryParams}`,
          storica: `${baseLink}?quotation_type=storica&${queryParams}`,
          'ruote-classiche': `${baseLink}?quotation_type=ruote-classiche&${queryParams}`,
        };
        return links[this.type];
      },
      description() {
        if (this.customDescription && this.customDescription.trim() !== '') {
          return this.customDescription;
        }
        return {
          nominale: `La <span class="text-bold">Quotazione Nominale Quattroruote</span> fornisce un certificato di valutazione...`,
          sponsor: `La <span class="text-bold">Quotazione Nominale Quattroruote</span> fornisce un certificato di valutazione...`,
          'live-market': `Il Report Live Market rappresenta uno strumento innovativo...`,
          storica: `La <span class="text-bold">Quotazione Storica</span> fornisce un certificato di valutazione completo...`,
          'ruote-classiche': `La Quotazione Ruote Classiche contiene la perizia dettagliata...`,
        }[this.type];
      },
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/CertificateExample.vue